import React from 'react'
import { BlobProvider } from '@react-pdf/renderer'
import ImprimirPdf from './ImprimirPdf'

const RenderPrintPdf = ({ pdfDocument, pdfToPrint, onAfterPrint }) => (
  <>
    <BlobProvider document={pdfDocument}>
      {({ blob }) => {
        if (blob && !pdfToPrint) {
          const reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onloadend = () => {
            onAfterPrint(reader.result)
          }
        }
        return null
      }}
    </BlobProvider>
    {pdfToPrint && <ImprimirPdf pdfBase64={pdfToPrint} onAfterPrint={onAfterPrint} />}
  </>
)

export default RenderPrintPdf
